import { defineComponent, type PropType } from "vue";
import { overlayStateStore } from "@/library/stores/OverlayStateStore";
import type { IOverlayConfig, IOverlayState } from "@/types/ComponentLibrary/component-library";
import VRuntimeTemplate from "vue3-runtime-template";

import { t } from "@/services/Translation/t";
export default defineComponent({
  name: "Overlay",
  components: {
    VRuntimeTemplate,
  },
  props: {
    identifier: { default: "" },
    index: { default: 1 },
    level: { default: 1 },
    mtdt: {
      type: Object as PropType<ITreeSection>,
      required: true,
    },
  },
  created() {
    window.FormEngine.form.registerOverlay(this.identifier, this);
  },
  data() {
    let store = overlayStateStore(this.identifier as string);
    let parent = window.FormEngine.form.sections.get(this.mtdt.Parent);

    if (!parent && this.level > 1) {
      parent = window.FormEngine.form.controls.get(this.mtdt.Parent);
      if (!parent) {
        console.log("Doesn't have a parent :( ", this.identifier, this.mtdt.Parent);
      }
    }

    if (store.reload) {
      store.state = {
        indicator: "unopened",
        visited: false,
        isValid: true,
        hiddenHint: true,
        hidden: true,
        isOpen: false,
        titleHidden: this.mtdt.HasHiddenCaption ? this.mtdt.HasHiddenCaption : false,
        descriptionHidden: !this.mtdt.Title ? true : false,
        skipValidation: false,
        parent: parent as any,
        controls: new Array<any>(),
        additional:{},
      } as IOverlayState;
      store.config = {
        classes: this.mtdt.Classes,
        isCustomView: false,
      } as IOverlayConfig;
    }
    store.reload = false;
    return {
      store: store,
      state: store.state as IOverlayState,
      config: store.config as IOverlayConfig,
    };
  },
  methods: {
    toggleHintSection() {
      this.state.hiddenHint = !this.state.hiddenHint;
    },
    toggleHide(){
      this.state.hidden = !this.state.hidden;
    },
    subscribe(event: string, callback: Function, specifier?: string) {
      window.FormEngine.events.subscribe(event, callback, this.identifier, specifier, null);
    },
    show(){
      this.state.hidden = false;
    },
    hide(){
      this.state.hidden = true;
    },
    t
  },
  computed: {
    additionalData(): any {
      return this.state.additional;
    },
    titleId(): string {
      return this.identifier + "-heading-" + this.level;
    },
    descriptionId(): string {
      return this.identifier + "-summary-" + this.level;
    },
    contentId(): string {
      return this.identifier + "-content-" + this.level;
    },
    hintId() {
      return this.identifier + "-hint";
    },
    displayDescription(): string {
      return t("Title", this.identifier);
    },
    descriptionHidden(): boolean {
      return this.state.descriptionHidden;
    },
    displayHint(): string {
      return t("Hint", this.identifier);
    },
    displayHintText(): string {
      return this.state.hiddenHint ? t("displayHintTextClosed", "_utility") : t("displayHintTextOpened", "_utility");
    },
    displayHintClasses(): string {
      return "govuk-display-hint " + (this.state.hiddenHint ? "hint-closed" : "hint-opened");
    },
    isVisited(): boolean {
      return this.state.visited;
    },
    displayTitle(): string {
      return t("Name", this.identifier);
    },
  },
});
